import { createSelector } from 'reselect';
import isEmpty from 'lodash/isEmpty';
import { selectedCarpetPad } from '../carpetPad';
import { totalProjectPrice, selectSelectedCarpetChoice } from '../pricing';
import { roomsArraySelector } from '../roomMeasure';
import { findTaggedValue } from '../../utils/tags';
import { configSelector } from '../config/configSelector';
import { getHdmsStoreDetails } from '../thdStoreInfo/getHdmsStoreDetails';
import { selectSelectedSkuData } from '../skuDataSelectors';

const canProceed = (rooms, carpet, carpetSku, paddingSku, estimateTotal, zipcode) => {
  const hasRoomNames = rooms && !isEmpty(rooms.map((rm) => rm.room).filter((id) => id));
  return hasRoomNames
    && carpetSku
    && paddingSku
    && carpet?.value
    && parseInt(estimateTotal, 10) > 0
    && zipcode;
};

const scheduleMeasureUrlSelector = createSelector(
  [configSelector,
    roomsArraySelector,
    selectSelectedCarpetChoice,
    selectedCarpetPad,
    totalProjectPrice,
    getHdmsStoreDetails,
    selectSelectedSkuData
  ],
  (config, roomsArray, carpet, padding, projectTotalCost, storeDetails, selectedSkuData) => {
    const { scheduleMeasureOnlyUrl, scheduleMeasureWithParamsUrl } = config;
    const { zipcode } = storeDetails;
    const carpetSku = !isEmpty(selectedSkuData)
      ? selectedSkuData?.hdmsSku
      : findTaggedValue(carpet?.tags || [], 'hdmssku');
    const paddingSku = findTaggedValue(padding?.tags || [], 'hdmssku');

    if (canProceed(roomsArray, carpet, carpetSku, paddingSku, projectTotalCost, zipcode)) {
      const params = {
        roomNames: roomsArray.map((rm) => rm.room),
        carpetSku,
        paddingSku,
        colorFamily: carpet.value,
        estimateTotal: projectTotalCost,
        zipCode: zipcode,
        isSuperSku: !isEmpty(selectedSkuData)
      };
      const queryParams = Object.entries(params).map((qp) => {
        return `&${qp[0]}=${qp[1]}`;
      });
      return ({
        params,
        samUrl: scheduleMeasureWithParamsUrl + encodeURIComponent(queryParams.join(''))
      });
    }
    return ({
      params: null,
      samUrl: scheduleMeasureOnlyUrl
    });
  }
);

export default scheduleMeasureUrlSelector;